import { useState, useEffect, useCallback } from "react";
import type { CartItem } from "@/lib/cart";

export function useAddToCartPopup() {
  const [addedItem, setAddedItem] = useState<CartItem | null>(null);

  useEffect(() => {
    const handleItemAdded = (e: Event) => {
      const customEvent = e as CustomEvent<{ item: CartItem }>;
      if (customEvent.detail?.item) {
        setAddedItem(customEvent.detail.item);
      }
    };

    window.addEventListener("itemAddedToCart", handleItemAdded);
    return () => window.removeEventListener("itemAddedToCart", handleItemAdded);
  }, []);

  const closePopup = useCallback(() => {
    setAddedItem(null);
  }, []);

  return { addedItem, closePopup };
}
